import { useAuthContext } from '@/contexts/AuthContext';

/**
 * Thin convenience hook over `<AuthProvider>` context · returns
 * `{user, isLoading, isAuthed, error, refreshMe, clearSession}`. Phase 3.3
 * skeleton: ping-based read-only access. Phase 3.7 extends with
 * `login` · `signup` · `logout` · `oauthCallback` methods.
 */
export const useAuth = useAuthContext;
